<template>
  <div>
    <form action="/" class="cta__add-to-cart" v-if="readyToNotify">
      <div class="form-group">
        This item is out of stock.
        <button
          type="submit"
          class="btn btn--full"
          :class="activeClass"
          v-if="isLoggedIn"
          @click.prevent="doNotifications">{{ buttonText }}</button>
        <p
          class="type-regular"
          v-if="!isLoggedIn">
          <button
            type="button"
            data-micromodal-trigger="login-modal"
            class="type-link"
            @click="toggleModal"
          >
            Log in
          </button>
          to add a notification.
        </p>
      </div>
    </form>
    <div class="modal login-modal" v-if="modalOpen">
      <div class="modal__overlay" tabindex="-1" data-micromodal-close>
        <div class="modal__container" role="dialog" aria-modal="true" aria-labelledby="modal-1-title" :aria-describedby="'modal-' + variant.Id">
          <div role="document">
            <header class="modal__header">
              <button class="modal__close" aria-label="Close modal" @click="toggleModal" aria-controls="modal__container1"></button>
            </header>
            <main class="modal__content flex add-large-bottom-padding" :id="'modal-' + variant.Id">
              <LoginModal :isMobile="false"></LoginModal>
            </main>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { mapActions } from 'vuex';
import { mapState } from 'vuex';

import { FETCH_NOTIFICATIONS } from '../vuex/modules/notifications/mutations';
import { ADD_NOTIFICATION } from '../vuex/modules/notifications/mutations';
import { DELETE_NOTIFICATION } from '../vuex/modules/notifications/mutations';

import LoginModal from './LoginModal.vue';

export default {
  name: 'NotifyMe',
  props: ['readyToNotify', 'variant'],
  components: {
      LoginModal,
  },
  data() {
    return {
      modalOpen: false,
    }
  },

  mounted() {
    this.$store.commit('setEndpoint');
    this.$store.commit('setCurrentVariantId', this.currentVariant.Id);

    if (this.isLoggedIn) {
      this.getNotifications();
    }
  },

  methods: {
    ...mapActions({
      FETCH_NOTIFICATIONS,
      ADD_NOTIFICATION,
      DELETE_NOTIFICATION
    }),

    getNotifications() {
      this.FETCH_NOTIFICATIONS().then(() => {
        this.setSelectedNotification();
      });
    },

    doNotifications() {
      if (this.hasActiveNotifications()) {
        this.deleteNotification();
      } else {
        this.addNotification();
      }
    },

    addNotification() {
      this.ADD_NOTIFICATION().then(() => {
        this.getNotifications();
      });
    },

    deleteNotification() {
      this.DELETE_NOTIFICATION().then(() => {
        this.getNotifications();
      });
    },

    hasActiveNotifications() {
      const isInNotifications = this.notifications.some(
        item => item.ProductVariantId == this.currentVariant.Id
      );
      return isInNotifications;
    },

    getSelectedNotification() {
      const currentVariant = this.currentVariant;
      return this.notifications.find(
        item => item.ProductVariantId == this.currentVariant.Id
      );
    },

    setSelectedNotification() {
      if (this.hasActiveNotifications) {
        const active = this.getSelectedNotification();
        if (active) {
          this.$store.commit('setActiveNotification', active);
        } else {
          this.$store.commit('setActiveNotification', this.notifications[0]);
        }
      } else {
        this.$store.commit('setActiveNotification', null);
      }
    },

    toggleModal(id) {
      this.modalOpen = !this.modalOpen;
    }
  },

  watch: {
    currentVariant() {
      if (this.isLoggedIn) {
        this.setSelectedNotification();
      }
    },

    isLoggedIn(loggedIn) {
      if (loggedIn) {
        this.FETCH_NOTIFICATIONS();
      }
    }
  },

  computed: {
    ...mapState({
      notifications: state => state.notificationsStore.notificatons,
      endpoint: state => state.notificationsStore.API_NOTIFICATIONS_ENDPOINT,
      activeNotification: state => state.notificationsStore.activeNotification,
      currentVariant: state => state.ProductVariantStore.currentVariant,
      isLoggedIn: state => state.AuthStore.isLoggedIn
    }),

    buttonText() {
      if (this.hasActiveNotifications()) {
        return 'Remove Notification';
      } else {
        return 'Notify Me';
      }
    },

    activeClass() {
      if (this.hasActiveNotifications()) {
        return 'btn--secondary';
      } else {
        return '';
      }
    }
  }
};
</script>


// WEBPACK FOOTER //
// resources/assets/js/components/NotifyMe.vue